import { useSelector } from 'react-redux';
import { useTranslatedMessages } from './useTranslatedMessages';
import { formatAccessDeniedMessage, getActionDeniedTemplate } from '../utils/accessDeniedMessage';

export function useAccessDeniedMessage(templateKey = 'action_denied') {
  const rootUserEmail = useSelector((state) => state.org.org?.root_user_email ?? '');
  const { common } = useTranslatedMessages();
  const template = getActionDeniedTemplate(common.access_denied, templateKey);

  return formatAccessDeniedMessage(template, rootUserEmail);
}
